export let onboarding = {
    LEGALADDR: 'LEGALADDR',
    LOCATIONADDR: 'LOCATIONADDR'
}

export let dashboard = {

}

export let Regex = {

    //PHONE_NUM: /^[0]{0,1}[1-9]{1}[0-9]{9,10}$/,
    PHONE_NUM: /^[+]{0,1}[0-9]{2,15}$/,
    EMAIL: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
    PINCODE: /^[1-9]{1}[0-9]{5}$/,

    LE_PAN: /^[A-Z]{3}[CHFATBLJG]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$/,
    BANK_PAN: /[A-Z]{3}[A-Z]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$/,
    EMPLOYEE_PAN: /[A-Z]{3}[A-Z]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$/,
    IT_EMPLOYEE_PAN: /[A-Z]{3}[A-Z]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$/,

    CIN: /^[UL]{1}[0-9]{5}[A-Z]{2}[1-9]{1}[0-9]{3}[A-Z]{3}[0-9]{6}$/,
    TAN: /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/,
    GST: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[12]{1}Z[0-9A-Z]{1}$/,

    IFSC: /^[A-Z]{4}[0]{1}[A-Z0-9]{6}$/,
    ALPHA_NUM: /^[a-zA-Z0-9 ]*$/,
    PASSWORD: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,12}$/,
    FORMULA:/^((\d+(\.?\d+))[*-+/])*([\[\(\{]['](DA|Basic|HRA|CA|STP|OT|Grt|LE|SB|EPF|ErPF|EPS|ErESIC|ESIC|ErLWF|LWF|PT|IT|ENPS|ErNPS|SA||NOTP|NOTR|devs|adas|new|payslip|nt|basic1|basic2|another|NAL|CTC|ffs_component|SPL-ALW|FD-ALW|car-alw)['][\]\)\}]([*-+/][0-9]+(.?[0-9]+))*)([*-+/][\[\(\{]['](DA|Basic|HRA|CA|STP|OT|Grt|LE|SB|EPF|ErPF|EPS|ErESIC|ESIC|ErLWF|LWF|PT|IT|ENPS|ErNPS|SA||NOTP|NOTR|devs|adas|new|payslip|nt|basic1|basic2|another|NAL|CTC|ffs_component|SPL-ALW|FD-ALW|car-alw)['][\]\)\}]([*-+/][0-9]+(.?[0-9]+))*)*/,
}

export let GlobalList = {

    countriesList: [{ id: "589d6571-3edf-4483-b7cc-5ef4fe3fbece", name: "India" }]
}

export let MaxLengthSettings = {
        nameLength: 1000,
        descriptionLength: 255
}